module.exports = require("/Users/mike/Documents/git/ppcat.github.io/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 469
// module chunks = 231608221292675